<template>
  <div id="smartcommerce_fleetware_cart" class="d-inline-block" @click="show()" :class="showCartTotal() ? 'cursor-pointer' : ''">
    <sc-cart>
      <template v-slot:cart>
        <div class="cart-label">{{ $t('cart.label') }}</div>
        <div class="total" v-if="showCartTotal()">{{ $t('cart.total', { total: $price(cartTotal()) }) }}</div>
      </template>
      <div slot="notification">{{ $t('cart.notification') }}</div>
    </sc-cart>
    <cart-summary id="cart-summary" v-show="showCartSummary" @close="close($event)" />
  </div>
</template>

<script>
import { ScCart } from 'smartcommerce-component-library'
import CartSummary from './CartSummary'

export default {
  components: {
    ScCart, CartSummary
  },
  data () {
    return {
      showCartSummary: false
    }
  },
  methods: {
    show () {
      if (this.$store.getters.getProductsInCart().length === 0) return
      this.showCartSummary = true
    },

    close ($event) {
      $event.stopPropagation()
      this.showCartSummary = false
    },

    showCartTotal () {
      return this.$store.getters.getProductsInCart().length > 0
    },

    cartTotal () {
      return this.$store.getters.getTotalNetCost()
    }
  }
}
</script>

<style lang="scss">
#smartcommerce_fleetware_cart {
  .sc-cart-container {
    min-width: 175px;

    & > div:first-child {
      height: 42px;
    }
  }

  .sc-cart-icon {
    margin-right: 8px;
  }

  .cart-label {
    margin-right: 6px;
    color: #37474f;
  }

  .total {
    font-weight: bold;
    color: #37474f;
  }

  .sc-cart-notification {
    line-height: 20px;
  }

  #cart-summary {
    height: max-content;
    z-index: 1648;
    position: absolute;
    width: 1560px;
    right: calc((100vw - 1560px)/2);
    top: 60px;
  }

  @media(max-width: 1560px) {
    #cart-summary {
      width: 100%;
      right: 0;
    }
  }
}

@media(max-width: 768px) {
  #smartcommerce_fleetware_cart{
    margin: 0px 8px !important;
    width: 30px;
  }

  .sc-cart-center-align{
    display: none !important;
  }

  .sc-cart-notification{
    display: none;
  }
}
</style>
